<template>
	<v-dialog v-model="open" max-width="450" v-cancel-delete-confirm="close" persistent>
		<v-card>
            <v-card-title class="red-dialog-title py-2">
                <span class="headline">{{ headline ? headline : $t('lang.confirm') }}</span>
                <v-spacer></v-spacer>
                <bc-btn-dialog-close
                    @invoke-method="invokeMethod($event)"
                    action="close"
                    :dialog-status="open"
                ></bc-btn-dialog-close>
            </v-card-title>
			<v-card-text class="pa-2 pt-3">
                <v-container grid-list-form>
                    <v-layout row wrap>
                        <v-flex xs12 class="title" v-if="heading"><b>{{ heading }}</b></v-flex>
                        <v-flex xs12 v-if="special">{{ special }}</v-flex>
                        <v-flex xs12>{{ message || $t('lang.confirm_delete_message') }}</v-flex>
                        <v-flex xs12>
                            <slot></slot>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn flat @mouseup.left="close()">{{ $t('lang.cancel') }}</v-btn>
				<v-btn color="error" @mouseup.left="$emit('onConfirm')">{{ $t('lang.confirm') }}</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
    props: ["heading", "message", "onConfirm", "deleteLoader", "special", "headline"],
    data() {
        return {
            open: false
        };
    },
    methods: {
        openDialog() {
            this.open = true;
        },
        close(emit = true) {
            if(this.open && emit){
                this.$emit('close');
            }
            this.open = false;
        },
    }
};
</script>